import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

//dropdown TIPOS DE OS
const DetalleTOS1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrTipoOS}</option>
  )
};

const ListaTOS = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleTOS1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrTipoOS" id="descrTipoOS" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown TIPOS DE OS
//dropdown CATEGORIAS DE OS
const DetalleCat1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrCategOST}</option>
  )
};

const ListaCat = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCat1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrCategOST" id="descrCategOST" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CATEGORIAS DE OS
//dropdown NODOS
const DetalleNodo1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrNodo}</option>
  )
};

const ListaNodo = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNodo1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrNodo" id="descrNodo" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown NODOS
//dropdown TIPOS DE RECURSO
const DetalleNivelTipoRec = props => {
  return (
    <option value={props.elemento.descrTipoRec}>{props.elemento.descrTipoRec}</option>
  )
};

const ListaTipoRec = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipoRec elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrTipoRec" id="descrTipoRec" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown TIPOS DE RECURSO
//dropdown RECURSOS TECNICA
const DetalleNivelTecnica = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaTecnica = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTecnica elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrRecurso" id="descrRecurso" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown RECURSOS TECNICA
//Lista de OS a las que se les va a asignar recusrso técnico
const AsigRec = ({elemento, empresaArchFE, handleChangeTar}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoSelecc' id={elemento.numeroOS} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeTar(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.nombreBarrio}</td>
      <td className=''>{elemento.descrNodo}</td>
      <td className=''>{elemento.numeroOS}</td>
      {empresaArchFE==="codisert" &&
        <td className=''>{elemento.cicloFact}</td>
      }
      <td className=''>{elemento.fechaCreate}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className=''>{elemento.descrTipoOS}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.direccion}</td>
      <td className=''>{elemento.observacAB}</td>
    </tr>
  )
};

const ListaAsigRT = ({list, empresaArchFE, handleChangeTar}) => {
  const nivel1Detalle = list.map((elemento, i) => <AsigRec elemento={elemento} key={i}
    empresaArchFE={empresaArchFE} handleChangeTar={handleChangeTar}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcATOS2 extends React.Component {
  state={argsDocum: {descrTipoOS: "Todos...", descrCategOST: "Todas...", descrNodo: "Todos...",
        numeroDocum: "", descrRecurso: "Seleccionar...", descrTipoRec: "Seleccionar...",
        descrDpto: "Todos...", nombreCiudad: "Todas...",
        nombreZona: "Todas...", nombreBarrio: "Todos..."},
        argsSelDpto: this.props.argsSelDpto, listaOSAb: [],
        totOSA: 0, checkQRT: true, permiteUpdate: true,
        confirmaAct: false, open: false, errors: [], opciones: "opcion1", checkTodo: true,}

  handleChange = (ev) => {
    // console.log(ev.target.name, ev.target.checked)
    let argsDocum = this.state.argsDocum
    if(ev.target.name !== "descrRecurso"&&ev.target.name !== "descrTipoRec"){
      let listaOSAb = []
      this.setState({totOSA: 0, listaOSAb})
    }
    if(ev.target.name==="opciones"&&ev.target.checked===true){
      this.setState({opciones: ev.target.value})
    }else{
      if(ev.target.name==="descrTipoRec"){
        argsDocum[ev.target.name] = ev.target.value
        argsDocum['numeroDocum'] = ""
        argsDocum['descrRecurso'] = "Seleccionar..."
      }else{
        if(ev.target.name === "descrRecurso"){
          let descrRecurso = document.getElementById("descrRecurso");
          if(descrRecurso.options[descrRecurso.selectedIndex].text==="Seleccionar..."){
            argsDocum['numeroDocum'] = ""
            argsDocum['descrRecurso'] = descrRecurso.options[descrRecurso.selectedIndex].text
          }else{
            argsDocum['numeroDocum'] = descrRecurso.options[descrRecurso.selectedIndex].attributes[0].value
            argsDocum['descrRecurso'] = descrRecurso.options[descrRecurso.selectedIndex].attributes[1].value
          }
        }else{
          if(ev.target.name==="descrTipoOS"||ev.target.name==="descrCategOST"||ev.target.name==="descrNodo"){
            argsDocum[ev.target.name] = ev.target.value
            if(ev.target.name === "descrTipoOS"){
              argsDocum['descrCategOST'] = "Todas..."
            }
          }else{
            if(ev.target.name === "checkQRT"){
              this.setState({checkQRT: ev.target.checked});
            }else{
              const argsDocum = this.state.argsDocum
              argsDocum[ev.target.name] = ev.target.value
            }
          }
        }
      }
    }
    // console.log(argsDocum)
    this.setState({argsDocum});
  }

  handleChangeTar = (ev, elemento) => {
    // console.log(ev.target.name, ev.target.id)
    // console.log(elemento)
    // console.log(this.state.listaOSAb.length)
    let listaOSAb=this.state.listaOSAb
    if(ev.target.name === "estadoSelecc" ||
        ev.target.name === "estadoSeleccTodo"
      ){
      if(ev.target.name === "estadoSeleccTodo"){
        let checkTodo = this.state.checkTodo

        listaOSAb.forEach((elemento1, i) => {
          if(checkTodo===false){
            listaOSAb[i].estadoSelecc = true
          }else{
            listaOSAb[i].estadoSelecc = false
          }
        })

        if(checkTodo===false){
          checkTodo = true
        }else{
          checkTodo = false
        }

        this.setState({checkTodo});
      }
      if(ev.target.name === "estadoSelecc"){
        const indexSearch = listaOSAb.findIndex( odes => odes.numeroOS === parseInt(ev.target.id, 10) );
        // console.log(indexSearch)
        if(indexSearch!==-1){
          if(elemento.estadoSelecc===false){
            listaOSAb[indexSearch].estadoSelecc = true
          }else{
            listaOSAb[indexSearch].estadoSelecc = false
          }
        }
      }

      this.setState({listaOSAb});
    }
  }

  handleSubmit = async (ev)=>{
    // console.log(ev.target.name)
    let targetName = ev.target.name

    //ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
      console.log("CRUD")
      if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
        const {data} = await operacionCRUD({
          variables: args
        });

        //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          // console.log("MANY")
          // console.log(args)
          // const {data} = await operacionCRUD({
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
  
    //ENVIO PARA ACTUALIZAR BD
    async function updColecc(crudColecc, argsCrud, totDocCRUD) {
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      let codigo = 0
      // console.log(argsCrud)
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      // console.log("inicio")
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
      console.log("final")
    }

  if(targetName==="pantalla"){
    // let codProcDX = new Date().getTime();
    document.body.style.cursor = 'wait'
    let argsUpd
    let errors = []
    if(!this.props.allOdeSRtes.allOdeSRtes){
      errors.push({path: "Asignar RT", message: "Proceso de asignar recurso técnico a OS ABIERTA, por favor espere un momento..."});
    }

    // console.log(this.state.argsDocum)
    // console.log(this.state.argsSelDpto)
    this.setState({errors})
    if(errors.length===0){
      let osAbierta = []
      let argsBuscarOS = ""
      if(this.state.argsDocum.descrCategOST&&this.state.argsDocum.descrCategOST!=="Todas..."){
        argsBuscarOS = `'descrCategOST': '${this.state.argsDocum.descrCategOST}'`
      }
      if(this.state.argsDocum.descrTipoOS&&this.state.argsDocum.descrTipoOS!=="Todos..."){
        if(argsBuscarOS){argsBuscarOS += `, `}
        argsBuscarOS += `'tipoos.descrTipoOS': '${this.state.argsDocum.descrTipoOS}'`
      }
      if(this.state.argsDocum.descrNodo&&this.state.argsDocum.descrNodo!=="Todos..."){
        if(argsBuscarOS){argsBuscarOS += `, `}
        argsBuscarOS += `'descrNodo': '${this.state.argsDocum.descrNodo}'`
      }
      if(this.props.descrTipoRec&&this.props.descrTipoRec!=="Todos..."){
        if(argsBuscarOS){argsBuscarOS += `, `}
        argsBuscarOS += `'descrTipoRecT': '${this.props.descrTipoRec}'`
      }

      if(this.state.opciones==="opcion1"){
        if(argsBuscarOS){argsBuscarOS += `, `}
        argsBuscarOS += `'impresa': false`
      }
      if(this.state.opciones==="opcion2"){
        if(argsBuscarOS){argsBuscarOS += `, `}
        argsBuscarOS += `'impresa': true`
      }

      //Seleccionar OS de clientes del dpto, ciudad, zona y barrio seleccionados
      if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
        }else{
          if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
            if(argsBuscarOS){argsBuscarOS += `, `}
            argsBuscarOS += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
            argsBuscarOS += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
          }else{
            if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              if(argsBuscarOS){argsBuscarOS += `, `}
              argsBuscarOS += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarOS += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarOS += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
            }else{
              if(argsBuscarOS){argsBuscarOS += `, `}
              argsBuscarOS += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarOS += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarOS += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              argsBuscarOS += `, 'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
            }
          }
        }
      }
      // console.log(argsBuscarOS)
      if(this.props.allOdeSRtes.allOdeSRtes){
        let tipoqry = `[
          {$match: {estadoOS: 'ABIERTA'}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$unwind: '$cliente'},
          {$project: {numeroOS: 1, contrato: 1, tipoos: 1, observacAB: 1, descrCategOST: 1,
            descrTipoRecT: 1, impresa: 1,
            usuarioCreate: 1, fechaCreate: 1, nombreBarrio: '$cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio',
            descrNodo: '$cliente.descrNodo', recursos: 1, dirmayor: '$cliente.dirmayor',
            direccion: '$cliente.direccion', codigoPaquete: '$cliente.nombreCliente',
            descrPaquete: '$cliente.apellidoCliente', descrClasifOST: '$cliente.cicloFact'}},`
        if(argsBuscarOS){
          argsBuscarOS = '{' + argsBuscarOS + '}'
          tipoqry += ` {$match: ${argsBuscarOS}},
            {$sort: {nombreBarrio: 1, descrNodo: 1, numeroOS: 1}}`
        }
        tipoqry += `]`
        argsBuscarOS = {tipoqry}
        // console.log(argsBuscarOS)
        let {data} = await this.props.allOdeSRtes.refetch(argsBuscarOS)
        osAbierta = await data.allOdeSRtes
      }
      // console.log(osAbierta.length)
      // console.log(this.state.argsDocum)
      let listaOSAb = []
      let totOSA = 0

      osAbierta.forEach((elemento, _id) => {
        argsUpd = {}
        let nombreBarrio = ""
        if(elemento.dirmayor&&elemento.dirmayor.ciudades&&elemento.dirmayor.ciudades.zonas&&elemento.dirmayor.ciudades.zonas.barrios&&elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio){
          nombreBarrio = elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio
        }else{
          if(elemento.dirmayor&&elemento.dirmayor.ciudades){
            nombreBarrio = elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio
          }                
        }

        let linea1DNN = ""
        if(elemento.direccion&&elemento.direccion.descrTipoVia1){
          linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
          linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
          linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
          linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
          linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
          linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
          linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
          linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
          linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
          linea1DNN = linea1DNN.substring(0, 40)
        }else{
          if(elemento.direccion&&elemento.direccion.descrTipoVia1){
            linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
            linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
            linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
            linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
            linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
            linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
            linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
            linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
            linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
            linea1DNN = linea1DNN.substring(0, 40)
          }
        }
        argsUpd = {
          "estadoSelecc": true,
          "numeroOS": elemento.numeroOS,
          "fechaCreate": elemento.fechaCreate.substr(0, 10),
          "usuarioCreate": elemento.usuarioCreate,
          "descrTipoOS": elemento.tipoos.descrTipoOS,
          "nombreBarrio": nombreBarrio,
          "descrNodo": elemento.descrNodo,
          "direccion": linea1DNN,
          "contrato": elemento.contrato,
          "nombreCliente": elemento.codigoPaquete,
          "apellidoCliente": elemento.descrPaquete,
          "observacAB": elemento.observacAB,
          "cicloFact": elemento.descrClasifOST?elemento.descrClasifOST:"",
          "recursos": elemento.recursos
        }
        listaOSAb.push(argsUpd)
        totOSA += 1
      })
      // console.log(listaOSAb)
      this.setState({listaOSAb})
      this.setState({totOSA})

      osAbierta = []
      let tipoqry = `[{$match: {estadoOS: 'XXX'}}]`
      argsBuscarOS = {tipoqry}
      if(this.props.allOdeSRtes.allOdeSRtes){
        let {data} = await this.props.allOdeSRtes.refetch(argsBuscarOS)
        osAbierta = await data.allOdeSRtes
      }
    }
    document.body.style.cursor = 'default'
  }
  if(targetName==="excel"){
    // var tableToExcel = (function() {
    //   var tmpElemento = document.createElement('a')
    //   //window.btoa => Encode a string in base-64
    //   var uri = 'data:application/vnd.ms-excel;base64,'
    //     , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
    //                         xmlns:x="urn:schemas-microsoft-com:office:excel">
    //                     <head>
    //                       <!--[if gte mso 9]>
    //                         <xml><x:ExcelWorkbook>
    //                               <x:ExcelWorksheets>
    //                                 <x:ExcelWorksheet>
    //                                   <x:Name>{worksheet}</x:Name>
    //                                   <x:WorksheetOptions><x:DisplayGridlines/>
    //                                   </x:WorksheetOptions>
    //                                 </x:ExcelWorksheet>
    //                               </x:ExcelWorksheets>
    //                             </x:ExcelWorkbook>
    //                         </xml>
    //                       <![endif]-->
    //                     </head>
    //                     <body><table>{table}</table></body>
    //                   </html>`
    //     , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    //     , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    //   return function(table, hoja) {
    //     if (!table.nodeType) table = document.getElementById(table)
    //     var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
    //     tmpElemento.href = uri + base64(format(template, ctx))
    //     tmpElemento.download = 'osabierta.xls';
    //     tmpElemento.click();
    //   }
    // })()

    // tableToExcel('tabla', 'osabierta')

    let xlsString = []
    let listaOSAb = this.state.listaOSAb
    // console.log(listaOSAb)
    let xlsString1 = []
    if(this.props.empresa.empresaArchFE==="codisert"){
      xlsString1 = ['# OS', 'Fecha Crea', 'Usuario Crea', 'Tipo de OS ', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Barrio', 'Nodo', 'Dirección', 'Observac al crear', 'Ciclo']
    }else{
      xlsString1 = ['# OS', 'Fecha Crea', 'Usuario Crea', 'Tipo de OS ', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Barrio', 'Nodo', 'Dirección', 'Observac al crear']
    }

    xlsString.push(xlsString1)

    for(let i=0; i<listaOSAb.length; i++){
      let fechaCreate = ""
      if(listaOSAb[i].fechaCreate){
        fechaCreate = new Date(listaOSAb[i].fechaCreate)
        fechaCreate = (fechaCreate.getUTCFullYear()) + '-' + ((fechaCreate.getUTCMonth()+1)<10?'0'+(fechaCreate.getUTCMonth()+1):(fechaCreate.getUTCMonth()+1)) + '-' + (fechaCreate.getUTCDate()<10?'0'+fechaCreate.getUTCDate():fechaCreate.getUTCDate())
        fechaCreate = new Date(fechaCreate+'T23:00:00.000Z')
      }
      if(this.props.empresa.empresaArchFE==="codisert"){
        xlsString1 = [listaOSAb[i].numeroOS, listaOSAb[i].fechaCreate, listaOSAb[i].usuarioCreate,
        listaOSAb[i].descrTipoOS, listaOSAb[i].contrato,
        listaOSAb[i].nombreCliente, listaOSAb[i].apellidoCliente,
        listaOSAb[i].nombreBarrio, listaOSAb[i].descrNodo, listaOSAb[i].direccion,
        listaOSAb[i].observacAB, listaOSAb[i].cicloFact]
      }else{
        xlsString1 = [listaOSAb[i].numeroOS, listaOSAb[i].fechaCreate, listaOSAb[i].usuarioCreate,
        listaOSAb[i].descrTipoOS, listaOSAb[i].contrato,
        listaOSAb[i].nombreCliente, listaOSAb[i].apellidoCliente,
        listaOSAb[i].nombreBarrio, listaOSAb[i].descrNodo, listaOSAb[i].direccion,
        listaOSAb[i].observacAB]
      }

      // console.log(xlsString1)
      xlsString.push(xlsString1)
    }
    // console.log(xlsString)

    var wb = XLSX.utils.book_new();

    wb.Props = {
      Title: "SheetJS Tutorial",
      Subject: "Test",
      Author: "Red Stapler",
      CreatedDate: new Date(2017,12,19)
    };
    
    wb.SheetNames.push("OS");
    
    let ws_data = xlsString;
    
    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets["OS"] = ws;
    let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    function s2ab(s) { 
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;    
    }
    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'osabierta.xlsx');
    //FIN Exportar a XLS
  }
  if(targetName!=="pantalla"&&targetName!=="excel"){
    let errors = []
    if(!this.props.allOdeSRtes.allOdeSRtes){
      errors.push({path: "Asignar RT", message: "Proceso de asignar recurso técnico a OS ABIERTA, por favor espere un momento..."});
    }
    if(this.state.listaOSAb.length===0){
      errors.push({path: "Asignar RT", message: "No hay OS seleccionadas para asignar recurso técnico"});
    }

    let indexSearchTR = this.props.allTipoRec.allTipoRec.findIndex( tiporec => tiporec.descrTipoRec===this.state.argsDocum.descrTipoRec )
    if(indexSearchTR===-1){
      errors.push({path: "Asignar TR", message: "Por favor seleccionar un Tipo de recurso válido"});
    }
    let indexSearchR = this.props.allRecurso.allRecurso.findIndex( recurso => recurso.numeroDocum===this.state.argsDocum.numeroDocum )
    // if(indexSearchR===-1){
    //   errors.push({path: "Asignar RT", message: "Por favor seleccionar un recurso técnico válido"});
    // }
    this.setState({errors})
    if(errors.length===0){
      document.body.style.cursor = 'wait'

      // let listaOSAb = this.state.listaOSAb
      let listaOSAb = this.state.listaOSAb.filter(elemento => elemento.estadoSelecc===true)
      // console.log(listaOSAb)
      
      let updRec = [], elimRec = []
      // let finProceso = false
      for(let ii=0; ii<listaOSAb.length; ii++){
        updRec = []
        elimRec = []
        let elemento = listaOSAb[ii]
        
        let numDocCRUD = 0
        let totDocCRUD = 1  
        let argsCrud = []
        let crudColecc = []

        if(indexSearchR!==-1){
          if(elemento.recursos&&elemento.recursos.length>0){
            for(let iii=0; iii<elemento.recursos.length; iii++){
              let argsDel = {
                "tipoAct": "EliminarRecurso",
                "numeroOS": elemento.numeroOS,
                "_idRecurso": elemento.recursos[iii]._id,
              };
              // console.log(argsDel)
              elimRec.push(argsDel)
              // this.actOdeS(argsDel)
            }
          }

          let argsUpd = {
            "tipoAct": "EditarRecursos",
            "numeroOS": elemento.numeroOS,
            "_idRecurso" : this.props.allRecurso.allRecurso[indexSearchR]._id,
            "codigoTipoDoc" : this.props.allRecurso.allRecurso[indexSearchR].codigoTipoDoc,
            "numeroDocum" : this.state.argsDocum.numeroDocum,
            "descrRecurso" : this.state.argsDocum.descrRecurso,
            "_idTipoRec" : this.props.allRecurso.allRecurso[indexSearchR].tiporec._id,
            "descrTipoRec" : this.props.allRecurso.allRecurso[indexSearchR].tiporec.descrTipoRec,
            "areaAprovech" : this.props.allRecurso.allRecurso[indexSearchR].tiporec.areaAprovech
          };
          // console.log(argsUpd)
          updRec.push(argsUpd)
          // this.actOdeS(argsUpd)

          // if(elemento.contrato==="34381"){
          //   console.log(updRec, elimRec, elimRec.length)
          // }

          if(elimRec.length>0){
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editOdeSUpdDoc)
            }

            argsCrud[numDocCRUD] = elimRec[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

            // console.log(argsCrud)
            await updColecc(crudColecc, argsCrud, totDocCRUD)
          }

          // numDocCRUD = 0
          // totDocCRUD = 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editOdeSUpdDoc)
          }

          argsCrud[numDocCRUD] = updRec[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

          // console.log(argsCrud)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }else{
          if(elemento.recursos&&elemento.recursos.length>0){
            for(let iii=0; iii<elemento.recursos.length; iii++){
              let argsDel = {
                "tipoAct": "EliminarRecurso",
                "numeroOS": elemento.numeroOS,
                "_idRecurso": elemento.recursos[iii]._id,
              };
              // console.log(argsDel)
              elimRec.push(argsDel)
              // this.actOdeS(argsDel)
            }
          }
          if(elimRec.length>0){
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editOdeSUpdDoc)
            }

            argsCrud[numDocCRUD] = elimRec[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

            // console.log(argsCrud)
            await updColecc(crudColecc, argsCrud, totDocCRUD)
          }

          let argsUpd = {
            "tipoAct": "EditarTipoRecT",
            "numeroOS": elemento.numeroOS,
            "descrTipoRec" : this.state.argsDocum.descrTipoRec,
          };
          // console.log(argsUpd)
          updRec.push(argsUpd)
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editOdeSUpdDoc)
          }

          argsCrud[numDocCRUD] = updRec[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

          // console.log(argsCrud)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        // if(ii===listaOSAb.length-1){
        //   finProceso = true
        // }
      }

      // if(finProceso){
        listaOSAb = []
        this.setState({totOSA: 0, listaOSAb})
  
        document.body.style.cursor = 'default'
        alert("!! Proceso finalizado !!")
      // }
    }
    // document.body.style.cursor = 'default'
  }
console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }
  
  async componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let listaOSAb = []
      this.setState({totOSA: 0, listaOSAb})
      }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
  }

  render(){
    const {argsDocum, listaOSAb, totOSA, checkQRT, permiteUpdate, confirmaAct, open, errors, checkTodo} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let listaTOS = []
    if(this.props.allTiposOS.allTiposOS){
      listaTOS = this.props.allTiposOS.allTiposOS
    }
    let listaCat = []
    if(this.props.allCategOST.allCategOST&&argsDocum.descrTipoOS&&argsDocum.descrTipoOS!=="Seleccionar..."){
      listaCat = this.props.allCategOST.allCategOST.filter(elemento => elemento.descrTipoOS===argsDocum.descrTipoOS)
    }
    
    let listaNodo = []
    if(this.props.allNodo.allNodo){
      listaNodo = this.props.allNodo.allNodo
    }

    let listaTR = []
    if(this.props.allTipoRec.allTipoRec){
      if(this.props.descrTipoRec==="Todos..."){
        listaTR = this.props.allTipoRec.allTipoRec.filter(elemento => elemento.areaAprovech==='TECNICA')
      }else{
        listaTR = this.props.allTipoRec.allTipoRec.filter(elemento => elemento.areaAprovech==='TECNICA' && elemento.descrTipoRec===this.props.descrTipoRec)
      }
    }
    // console.log(listaTR)
    // console.log(this.props.descrTipoRec)
    let listaRT = []
    if(this.props.allRecurso.allRecurso&&argsDocum.descrTipoRec&&argsDocum.descrTipoRec!=="Seleccionar..."){
      listaRT = this.props.allRecurso.allRecurso.filter(elemento => elemento.tiporec.descrTipoRec===argsDocum.descrTipoRec)
    }
    // console.log(listaRT)

    // if(this.props.allOdeSRtes.allOdeSRtes){
    //   console.log(this.props.allOdeSRtes.allOdeSRtes)
    // }
    let mensaje = "ASIGNAR"
    let imgIcon = "images/archivo_32.png"

    // let labelSelecc = "SELECCIONAR LAS ORDENES"
    let labelSelecc = ""
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large edit yellow icon"></i>
          Asignar recurso técnico a OS ABIERTA
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <h1 style={{color: '#2C7744'}}>Asignar recurso técnico a OS ABIERTA</h1>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Opciones&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Sin imprimir&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Impresas&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todas</label>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Tipo de OS
                        </label>
                        <ListaTOS styles={this.props.styles} list={listaTOS} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Categoría de OS
                        </label>
                        <ListaCat styles={this.props.styles} list={listaCat} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <hr></hr>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles}
                          handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles}
                          handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Nodo
                        </label>
                        <ListaNodo styles={this.props.styles} list={listaNodo} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total OS:&nbsp;
                  {totOSA}
                </p>

                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                        VER OS
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <p style={{color: 'green', fontSize: '1.7em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Seleccionar Recurso Técnico que se va a asignar a las OS
                </p>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Tipo de Recurso
                        </label>
                        <ListaTipoRec styles={this.props.styles} list={listaTR} handleChange={this.handleChange} />
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Recurso
                        </label>
                        <ListaTecnica styles={this.props.styles} list={listaRT} handleChange={this.handleChange} />
                      </Form.Field>
                    </div>
                  </div>
                </div>
                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <hr></hr>
                <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                  <div className='ui fitted slider checkbox'>
                    <input style={{paddingLeft: '0.7em', paddingRight: '0.7em'}} type='checkbox' name='estadoSeleccTodo' checked={checkTodo} onChange={(ev)=>this.handleChangeTar(ev)}/>
                    <label />
                  </div>
                <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{labelSelecc}</a>

                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''></th>
                        <th className=''>Barrio</th>
                        <th className=''>Nodo</th>
                        <th className=''># OS</th>
                        {this.props.empresa.empresaArchFE==="codisert" &&
                          <th className=''>Ciclo</th>
                        }
                        <th className=''>Fecha Crea</th>
                        <th className=''>Usuario Crea</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''>Dirección</th>
                        <th className=''>Observac al crear</th>
                      </tr>
                    </thead>
                    <ListaAsigRT list={listaOSAb} empresaArchFE={this.props.empresa.empresaArchFE} handleChangeTar={this.handleChangeTar}/>
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarOS}}}),
  graphql(queries.query.allOdeSRtes, {name:'allOdeSRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {estadoOS: "XXX"}}]`}}}}),

  // graphql(queries.query.allTipoRec, {name:'allTipoRec', options: (props) => {return {variables: {areaAprovech: 'TECNICA'}}}}),
  graphql(queries.query.allTipoRec, {name:'allTipoRec'}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allCategOST, {name:'allCategOST'}),
  graphql(queries.query.allNodo, {name:'allNodo'}),

  graphql(queries.mutation.editOdeSUpdDoc, {name:'editOdeSUpdDoc'}),

  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(ProcATOS2)
